import React from "react";
import Navbar from "./Essentials/Navbar";
import "./Css/About.css";
import Footer from "./Essentials/Footer";
import { useLocation } from "react-router-dom";

const About = () => {
  const router = useLocation();

  async function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  var i = 0;
  var j = 0;
  async function DynamicPictures(i, j) {
    var PICS = [
      "code0.png",
      "code1.png",
      "code2.png",
      "code4.jpg",
      "code5.jpg",
      "code6.png"
    ];
    var PICS2 = ["code0.png", "code1.png", "code3.png"];
    document
      .getElementById("dynamicImage")
      .setAttribute("src", "programming-pics/" + PICS[i % PICS.length]);
    document
      .getElementById("dynamicImage2")
      .setAttribute("src", "program-png-pics/" + PICS2[j % PICS2.length]);
    i++;
    j++;
    await sleep(7000);
    DynamicPictures(i, j);
  }
  React.useEffect(() => {
    // DynamicPictures(i, j);
  });


  var _in_ = window.screen.width > 900 ? 0 : 1;

  return (
    <>
      <Navbar />
      <div id="about" className="About">
        <center><br />
          <p id="information">
            <b>National Federation for Research in Advanced Computing (NFRAC)</b>{" "}
            <br /><br />
            National Federation for Research in Advanced Computing (NFRAC) is a research and development organisation related to advanced computation. The organisation is involved in science, engineering and technology to harvest the benefits of algorithms for problem solving and the mankind. NFRAC is a major constituent of the Department of Computer Science & Engineering (CSE).<br /><br />

            NFRAC was previously the Code Infinity Research and Development Organization (CIRDO), set up and envisioned by Er. P. Rohit V. Acharya. NFRAC was formed on January 17, 2020 and superseded CIRDO with an expanded role to harness computer science & technology.<br /><br />
            The primary objective of NFRAC is the research and development of the computer science and technology which satisfies the needs of people who aspire to make much out of technology.
            <br />

            <div id="dcomp" className="text">

              <p>
                We follow a four-step rule that is <b>THINK</b>, <b>LEARN</b>, <b>PRACTISE</b>, <b>IMPLEMENT</b>, <b>SUCCEED</b> and repeat the same in a loop. <br /> <b>THINK</b> differently, unlike others, THINK into the extremeties of the subject and interrogate HOW it happened rather than WHY. On learning HOW, we can find an answer for WHY. You should start thinking precisely, figure out the pros and cons of your thoughts and reason out practically. Stay hungry to <b>LEARN</b> something new and simultaneously work on what you are learning. Set your goals for today, plan for tomorrow, learn from yesterday's mistakes and build yourself. Schedule your time table for what all you should be learning and working on for the day.{" "}<b>PRACTISE</b> what you have learnt, because practise makes you perfect. Try out every single method that you can with what you have learnt to make it happen in a better and efficient way.
              </p>
            </div>
            <center>

              <img style={{
                width: window.screen.width > 750 ? "90%" : "100%",
                borderRadius: "20px",
                boxShadow: "0px 0px 9px 1px #CCCCCC"
              }} src="org.png" />
            </center>
            <div className="text rev">
              <p>
                <b>IMPLEMENT</b> it everyday and never stop working, not to be astonished, if you need to spend all your day on it. By following our four factors, you can make it to your success. Because <b>SUCCESS</b> is a long journey, in which you have been left with the power knowledge and time. So, use your time precisely and knowledge magnificiently to record your success and celebrate your victory everyday that you have spent learning, as this is how you <b>SUCCEED</b>.
              </p>

            </div>
            <p style={{ marginTop: "10px", textAlign: "justify" }}>
              <b>NFRAC</b> is structured into three principal wings: Research & Development, Engineering & Solutions and Training & Education. The Research and Development wing (NFRAC-Lab) serves as the autonomous core of NFRAC, comprising specialized departments including VPLD (Veda Programming Language Development), AIRD (Artificial Intelligence Research and Development), CSRD (Cyber Security Research and Development), and GPLD (Garuda Programming Language Development). This wing undertakes fundamental and applied research, develops core software, and designs tools and frameworks that support the operational activities of the VTC.
              <br />
              <b>The Engineering and Solutions wing - Viśvakarmān Technological Center (VTC)</b> implements NFRAC-Lab's research outputs into end-to-end software solutions, managing both internal and client projects. Antar Systems focuses on developing in-house software that converts research findings into practical applications, while Vyapti Solutions delivers customized solutions tailored to client requirements.
              <br />
              <ul style={{ paddingLeft: "20px" }}>
                <li>
                  <b>Tattva-AI Org</b> operates as the dedicated implementation engine within the VTC. It serves as the bridge between theoretical innovation and functional software, specifically operationalizing the breakthroughs generated by the NFRAC - AIRD (Artificial Intelligence Research & Development) Department.
                </li>
                <li>
                  <b>Yaari Org</b> is an independent organization dedicated to redefining social connectivity through high-performance engineering and real-time geographical intelligence. Moving beyond traditional social networking, Yaari focuses on bridging the gap between digital interaction and physical presence, creating a "hyper-local" ecosystem for users to discover both people and places.
                </li>
                <li>
                  <b>ITTaHub Org</b> is an independent organization within the ecosystem focused on building high-performance developer tools and distributed storage solutions. Its primary mission is to solve the complexities of cross-node synchronization and secure file management, providing students/developers with a streamlined, industrial-grade alternative to traditional repository management.
                </li>
                <li>
                  <b>EdFlix Org</b> is a dedicated division focused on the development and management of a secure, full-stack video delivery ecosystem. Specifically engineered for educational and programming content, EdFlix bridges the gap between high-quality media streaming and low-latency accessibility, ensuring a seamless learning experience for a global user base.
                </li>
                <li>
                  <b>Antar Core Org</b> serves as the central engineering backbone of the Viśvakarmān Technological Center (VTC). As the primary "Home Ground" development team, its mission is to build, maintain, and optimize the proprietary infrastructure and internal tools that power all other divisions. While Tattva-AI focuses on intelligence and Yaari on social connectivity, Antar Core ensures the underlying technology of the entire ecosystem is robust, scalable, and secure.
                </li>
                <li>
                  <b>MCG</b> is an independent consulting organization dedicated to high-level client engagement and technical strategy. Unlike internal divisions, MCG operates with a pure focus on the external market, bridging the gap between complex business challenges and high-performance engineering.
                </li>
              </ul>
              <b> The Training and Education wing - Information Technology Traning Academy </b> <a href="https://nfrac-in.web.app/nfrac_education">
                (ITTacademy)
              </a>, established as NFRAC-Edu on 16 December 2021, functions as an autonomous center focused on cultivating skilled engineers by providing structured education in programming and computer science, thereby preparing professionals to address the technological needs of the nation.
              <br /> Collectively, these autonomous and operational wings constitute an integrated ecosystem that advances research, technology development, product implementation, and human resource development in a coordinated and strategic manner.
            </p>
          </p>
        </center>
        <p id="name"> - Er. P. Rohit V. Acharya</p>
      </div><br />

      <br />
      <Footer />
    </>
  );
};
export default About;
